var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76471 1.18233C1.43983 1.18233 1.17647 1.44569 1.17647 1.77057V13.8176C1.17647 14.1425 1.43983 14.4059 1.76471 14.4059H10.9586V15.5823H1.76471C0.790088 15.5823 0 14.7922 0 13.8176V1.77057C0 0.795946 0.790085 0.00585938 1.76471 0.00585938H6.02021C6.50748 0.00585938 6.97307 0.207343 7.30664 0.562558L9.20884 2.58826C9.32003 2.70666 9.47523 2.77382 9.63765 2.77382H15.8824C16.857 2.77382 17.6471 3.56391 17.6471 4.53853V8.73323H16.4706V4.53853C16.4706 4.21366 16.2072 3.95029 15.8824 3.95029H9.63765C9.15038 3.95029 8.68478 3.74881 8.35122 3.3936L6.44901 1.3679C6.33783 1.24949 6.18263 1.18233 6.02021 1.18233H1.76471ZM15.8789 13.8057V10.7941H17.0554V13.8057H19.9984V14.9822H17.0554V17.9941H15.8789V14.9822H12.9396V13.8057H15.8789Z",
    fill: "#878A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderMedium);
export default __webpack_public_path__ + "static/media/folder-medium.ca85551a7a060cf506def38a2a819e6b.svg";
export { ForwardRef as ReactComponent };